import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useEffect, useState, useRef} from "react";
import Offcanvas from "react-bootstrap/Offcanvas";

import {SwalAlertClass} from "core/swalClass";
import {useTranslation} from "react-i18next";
import {translations} from "../translations";
import axiApi from "ApiCaller";
import Form from "react-bootstrap/Form";
import useCustomTranslation from "core/customTranslation";
import ManagerShipsForm from "./models/form/ManagerShipsForm";
import {useNavigate} from "react-router-dom";
import FormButton from "components/buttons/FormButton";

const FormShip = ({show, setShow, item, models}) => {
    const {t: _Tf} = useTranslation("forms");
    const {t: _TC} = useCustomTranslation(translations);
    const navigate = useNavigate();
    const Alert = new SwalAlertClass({confirmButtonText: _TC("button.accept")});
    const formRef = useRef();
    const [formData, setFormData] = useState({...item});
    const [model, setModel] = useState("");
    const [intervalType, setIntervalType] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setFormData(item);
        setModel(item.model);
        setIntervalType(item.interval_type);
    }, [item, models]);

    const handleClose = () => setShow(false);

    const onChange = (e) => {
        const {name, value} = e.target;
        setFormData((prev) => ({...prev, [name]: value}));
        if (name === "model") {
            setModel(value);
        }
    };

    const onIntervalTypeChange = (e) => {
        const value = e.target.value;
        setIntervalType(value);
        setFormData((prev) => ({...prev, interval_type: value}));
    };

    const handleSubmit = () => {
        let form = new FormData(formRef.current);
        // Use formData state directly (controlled form)
        let data = {};

        for (let [key, value] of form.entries()) {
            data[key] = value;
        }

        if (!data.name || !data.model) {
            Alert.error("Error", _TC("message.error.required"));
            return;
        }

        data.interval_type = intervalType || data.interval_type || "con";

        setIsLoading(true);
        // Send JSON payload (axiApi will stringify)
        axiApi.post(`/api/devices/configs/ships/save/`, data).then((resp) => {
            Alert.success(_TC("message.success.title"), _TC("message.success.text"))
                .then(() => {
                    navigate(0);
                })
                .finally(() => {
                    setIsLoading(false);
                });
        });
    };

    return (
        <>
            <Offcanvas
                show={show}
                onHide={handleClose}
                placement="end"
                backdrop="static"
                style={{width: "80%", fontSize: "15px"}}>
                <Offcanvas.Header className="preview-canvas">
                    <div className="preview-icon">
                        <FontAwesomeIcon icon="fa-solid fa-wrench" />
                    </div>
                    <div className="preview-title">
                        <Offcanvas.Title>
                            <div className="preview-title">
                                <label>{_TC("preview.add.ship")}</label>
                                <div>{formData.name}</div>
                            </div>
                        </Offcanvas.Title>
                    </div>
                </Offcanvas.Header>
                <Offcanvas.Body className="pt-0" style={{fontSize: "13px"}}>
                    <form ref={formRef} className="container-fluid" onSubmit={(e) => e.preventDefault()}>
                        <input type="hidden" name="id" value={formData.id || ""} readOnly />
                        <div className="row">
                            <div className="col-md-4 col-12">
                                <label>{_Tf("common.name")}</label>
                                <input
                                    type="text"
                                    className="form-control mb-2"
                                    id="name"
                                    name="name"
                                    value={formData.name || ""}
                                    onChange={onChange}
                                    required
                                />
                            </div>
                            <div className="col-md-3 col-12">
                                <label>{_TC("field.model")}</label>
                                <Form.Select
                                    className="mb-2"
                                    id="model"
                                    name="model"
                                    value={model}
                                    style={{width: "120px"}}
                                    onChange={onChange}>
                                    <option value="">{_TC("field.select")}</option>
                                    {models.map((m, index) => (
                                        <option key={index} value={m}>
                                            {m}
                                        </option>
                                    ))}
                                </Form.Select>
                            </div>
                        </div>
                        <div className="row d-flex">
                            <ManagerShipsForm
                                item={formData}
                                intervalType={intervalType}
                                onIntervalTypeChange={onIntervalTypeChange}
                                onFieldChange={onChange}
                            />
                        </div>
                    </form>

                    <div className="p-3 buttons-footer">
                        <div className="position-fixed bottom-0 end-0 mb-3 me-5">
                            <button type="button" className="btn btn-secondary" onClick={handleClose}>
                                {_TC("button.cancel")}
                            </button>
                            <FormButton className="btn btn-primary ms-4" onClick={handleSubmit} isProcessing={isLoading}>
                                {_TC("button.save")}
                            </FormButton>
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

export default FormShip;
